<script setup>
import { useField, ErrorMessage } from 'vee-validate';
import { toRef } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    label: {
        type: String,
        required: true
    },
    value: {
        type: Boolean
    }
});
const name = toRef(props, 'name');
const { value: inputValue, handleChange } = useField(name, undefined, {
    initialValue: props.value
});
</script>
<template>
    <div class="tw-mb-4">
        <label class="tw-flex">
            <input
                class="tw-hidden"
                type="checkbox"
                :name="name"
                :checked="inputValue"
                @change="handleChange($event.target.checked)"
            />

            <div class="checkbox__faux-input tw-flex-none" />

            <div>
                <span>{{ label }}</span>
                <ErrorMessage
                    :name="name"
                    class="tw-text-sm tw-mt-2 tw-mb-4 tw-text-red tw-block"
                />
            </div>
        </label>
    </div>
</template>
